module.exports = "<ng-container *ngIf=\"content$ | async as content\">\n    <vdgm-select class=\"row-picker\" [items]=\"selectItems\" (onSelect)=\"onItemSelect($event)\" [selectedValue]=\"selectedItem\"></vdgm-select>\n    <div class=\"selected-item\" *ngIf=\"selectedItem; let item\">\n        <lazy-item-list [list]=\"item\" [paginate]=\"paginate\" [config]=\"config\"></lazy-item-list>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/list/row-select-list/row-select-list.template.html
// module id = 763
// module chunks = 2